import React, { DetailedHTMLProps, HTMLAttributes } from "react";

const style = {
    background: "#606a7b",
    opacity: "0.7",
    height: "1px",
    border: "none",
    padding: 0,
    margin: 0,
};

export function SubscriptionPreferencesHrComponent({ className = null }) {
    const props: DetailedHTMLProps<
        HTMLAttributes<HTMLHRElement>,
        HTMLHRElement
    > = {
        style,
    };
    if (className) props.className = className;

    return <hr {...props} />;
}
